import type React from "react"

interface ErrorSummaryProps {
  errors: string[]
  maxVisible?: number
}

const ErrorSummary: React.FC<ErrorSummaryProps> = ({ errors, maxVisible = 3 }) => {
  if (errors.length === 0) return null

  return (
    <div className="error-summary">
      <h3>Sync Errors ({errors.length})</h3>
      <div className="error-list">
        {errors.slice(0, maxVisible).map((error, index) => (
          <div key={index} className="error-item">
            <span className="error-icon">⚠️</span>
            <span className="error-text">{error}</span>
          </div>
        ))}
        {errors.length > maxVisible && (
          <div className="error-item">
            <span>+{errors.length - maxVisible} more errors</span>
          </div>
        )}
      </div>
    </div>
  )
}

export default ErrorSummary
